<template>
  <div class="container">
    <div class="credit-explainer">
      <h2>StingyCat's Guide to Decoding Credit Reports</h2>
      <div v-for="(section, index) in creditSections" :key="index" class="credit-section">
        <h3>{{ section.title }}</h3>
        <p>{{ section.explanation }}</p>
      </div>
    </div>
  </div>
  <div class="stylish-links">
          <h3>🔗 Important Links 🖇️</h3>
          <ul>
            <li><a href="https://my.equifax.ca/consumer-registration/?lang=en" target="_blank">Free Equifax Credit Report</a></li>
            <li><a href="https://www.transunion.ca/product/consumer-disclosure#articleSection4" target="_blank">Free TransUnion credit report</a></li>
            <li><a href="https://www.consumer.equifax.ca/personal/dispute-credit-report/" target="_blank">Dispute information on your Equifax credit report</a></li>
            <li><a href="https://www.transunion.ca/assistance/credit-report-disputes" target="_blank">Dispute information on your Transunion credit report</a></li>
            
          </ul>
        </div><br><br><br><br><br><br>
</template>

<script setup>
import { ref } from 'vue';

const creditSections = ref([
  { 
    title: "Personal Information 🐾", 
    explanation: "Think of this as your kitty ID tag! It's got your name, previous names (aliases), current and past addresses, and stuff like that. No secrets here! The key aspect here is making sure this is all correct and you do not see any names or addresses you do not recognize. You do not want any stray cats lingering around your personal space." 
  },
  { 
    title: "Credit Summary 🎉", 
    explanation: "This is like your report card for adulting! It tells you how much credit you have in total, what kind of accounts, and if you’ve been a good kitty with your finances.  A lot of us have cards we may have and forgotten about (like those store cards around Christmas you get 30% extra off). It's a great snapshot of your credit life." 
  },
  { 
    title: "Account Information 🎁", 
    explanation: "These are your treasure chests! Each box tells a story about a credit account you have, like a credit card or a loan. Keep these chests full and shiny!  It will show potential lenders how long you have had an account so be careful to ever close any of your cards even if they have been paid off.  I know it's exciting, like that feeling of getting a new cardboard box for me, to finally pay off a credit card however by closing that account it can actually lead to a lower credit score.  Unfair, absolutely but that's a human's life.  The good news is if you are aware of the tricks to get your score higher you'll be able to win at this game.  One trick is to try and keep your credit utilization score below 35% which means if you have a credit limit of $10000 try and keep your outstanding balance, if you do not pay your cards off in full, below $3500.  If you must and your credit card company offers you a higher amount of pre-approved credit (which usually does not touch your credit score) you can get a lower credit utilization as a result. " 
  },
  { 
    title: "Inquiries 🕵️‍♀️", 
    explanation: "Who's been sniffing around your litter box? This section lists all the peeps who checked your credit recently.  There are hard checks and soft checks.  Hard checks are like when you get a mortgage, or a car loan.  They will actually decrease your credit score so avoid them unless absolutely necessary. A good idea to estimate when you think you'll need to borrow credit and avoid any hard checks up to 2 years beforehand.  I know it can be difficult to do so but a higher credit score can lead to more credit being granted and lower interest rates only available to a select few. " 
  },
  {
    title: "Public Records 🏛️",
    explanation: "Uh-oh! This is like the detention room of your report. Bankruptcies or court judgments go here. Let's stay out of this room, shall we?  Ideally you'll never get to this point, especially with StingyCat's help, however even something as catasphroic as bankruptcy really isn't the end of your credit life.  It'll be seven years in the timeout box but you'll get a chance to start over again.  Before you ever get to that point there are lots of resources available to help you including credit management services or if you really need someone to help listen and offer resources just send a meow to StingyCat directly at credithelp@stingycat.com.  We can figure this out together."
  },
  {
    title: "Errors on your report  ❌",
    explanation: "Ooopsies, someone messed up and now there are items on your report that you have never seen before.  Don't fret as unfortunately mistakes happen but there are ways to correct them.  We've included links to the major credit companies Equifax and Transunion on how to correct those mistakes."
  },
  {
    title: "Upload your credit report 📎",
    explanation: "If you would like to upload your credit report StingyCat can provide a detailed analysis in simple terms of how to interpret it and give you tips about how to increase your credit score."
  }
]);
</script>

<style scoped>
.credit-explainer {
  background-color: #f4f4f4;
  padding: 20px;
  border-radius: 10px;
}

.credit-section {
  margin-bottom: 20px;
}
</style>
  

<style scoped>
.container {
  background-color: #4A148C;
  color: black;
  padding: 20px;
  border-radius: 20px;
}


.content {
  background-color: white;
  padding: 20px;
  border-radius: 10px;
  color: black;
}
.stylish-links {
  background: linear-gradient(90deg, rgba(255,255,255,1) 0%, rgba(240,240,240,1) 100%);
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 4px 6px rgba(0,0,0,0.1);
}

.stylish-links h3 {
  color: #333;
  font-size: 1.4em;
  margin-bottom: 15px;
}

.stylish-links ul {
  list-style: none;
  padding: 0;
}

.stylish-links ul li {
    background-image: linear-gradient(135deg, #6D5BBA 0%, #8D58BF 100%); /* Apply the same gradient as your app theme */
  color: white;
  border: none;
  padding: 10px 15px;
  border-radius: 5px;
  margin: 5px;
  cursor: pointer;
  transition: background-color 0.3s, box-shadow 0.3s;
  }
  
  .stylish-links ul li a {
    color: white;
    text-decoration: none;
    font-weight: bold;
  }
  
  .stylish-links ul li:hover {
    background-image: linear-gradient(135deg, #8D58BF 0%, #6D5BBA 100%); /* Slightly adjust gradient for hover effect */
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2); /* Add a shadow for depth */
  }
  
  .stylish-links ul li:hover a {
    color: #fff;
  }
</style>